window['$'] = window['jQuery'] = require('jquery');
window['numeral'] = require('numeral');
window['moment'] = require('moment');

require('core-js-lib');

require('angular');
require('utility-pusher');
require('pusher-angular');
require('angular-strap');
require('angular-sanitize');
require('angular-ui-router');
require('angular-ui-event');
require('angular-ui-indeterminate');
require('angular-ui-mask');
require('angular-ui-scroll');
require('angular-ui-scrollpoint');
require('angular-ui-uploader');
require('angular-ui-validate');
require('angular-ui-utils');
require('angular-aria');

require('ui-router-extras/release/modular/ct-ui-router-extras.core.min');
require('ui-router-extras/release/modular/ct-ui-router-extras.core.min');
require('ui-router-extras/release/modular/ct-ui-router-extras.dsr.min');
require('ui-router-extras/release/modular/ct-ui-router-extras.sticky.min');
require('ui-router-extras/release/modular/ct-ui-router-extras.transition.min');
require('ui-router-extras/release/modular/ct-ui-router-extras.previous.min');

require('./lib/main');

/* ANGULAR V1 AUTO-LOADED RESOURCES */
require('data-ng-authentication');
require('data-ng-custom-text');
require('data-ng-path-item');
require('data-ng-personal-reminders');
require('data-ng-staff-todos');
require('ui-ng-animation');
require('ui-ng-ax');
require('ui-ng-button');
require('ui-ng-calendar-time');
require('ui-ng-core-bootstrap');
require('ui-ng-drag-drop');
require('ui-ng-draggable');
require('ui-ng-dropdown');
require('ui-ng-feature');
require('ui-ng-modal');
require('ui-ng-notification');
require('ui-ng-pie');
require('ui-ng-popover');
require('ui-ng-progress');
require('ui-ng-session-timer');
require('ui-ng-sibling');
require('ui-ng-smooth-scroll');
require('ui-ng-sticky');
require('ui-ng-svg-icons');
require('ui-ng-time-input');
require('ui-ng-tooltip');
require('ui-ng-validation');
require('ui-ng-university-text');
require('ui-ng-app-content');
require('ui-ng-browser-detect');
require('ui-ng-calendar');
require('ui-ng-component-communicator');
require('ui-ng-content-tabs');
require('ui-ng-content-tile');
require('ui-ng-delegate');
require('ui-ng-mobile-date-picker');
require('ui-ng-navbar');
require('ui-ng-popup');
require('ui-ng-refresh-button');
require('ui-ng-resource-card');
require('ui-ng-route-modal');
require('ui-ng-schedule-appointment-card');
require('ui-ng-search-box');
require('ui-ng-sgd-components');
require('ui-ng-university-branding');
require('ui-ng-week-times');
require('utility-ng-log');
require('utility-ng-network-cache');
require('utility-ng-pipeline');
require('utility-ng-time');
require('utility-ng-webcrypto');
require('utility-ng-auth-token');
require('utility-ng-configuration');
require('utility-ng-enumeration');
require('utility-ng-interface');
require('utility-ng-kernel');
require('utility-ng-progression');
require('utility-ng-type');
require('capability-ng-academic-planner');
require('capability-ng-appointments');
require('capability-ng-authentication');
require('capability-ng-conversations');
require('capability-ng-course-schedule');
require('capability-ng-deeplink');
require('capability-ng-favorites');
require('capability-ng-holds');
require('capability-ng-major-explorer');
require('capability-ng-notification-settings');
require('capability-ng-poll');
require('capability-ng-priority-feed');
require('capability-ng-reports');
require('capability-ng-resources');
require('capability-ng-scheduler');
require('capability-ng-settings');
// require('capability-ng-student-scheduling');
require('capability-ng-study-groups');
require('capability-ng-survey');
require('capability-ng-todos');
require('biz-ng-career-details');
require('biz-ng-path-placement');
require('biz-ng-requisite-tree');
require('hybrid-ng-personal-reminders');

angular.module('vendor', [
  'data-ng-authentication',
  'data-ng-custom-text',
  'data-ng-path-item',
  'data-ng-personal-reminders',
  'data-ng-staff-todos',
  'ui-ng-animation',
  'ui-ng-ax',
  'ui-ng-button',
  'ui-ng-calendar-time',
  'ui-ng-core-bootstrap',
  'ui-ng-drag-drop',
  'ui-ng-draggable',
  'ui-ng-dropdown',
  'ui-ng-feature',
  'ui-ng-modal',
  'ui-ng-notification',
  'ui-ng-pie',
  'ui-ng-popover',
  'ui-ng-progress',
  'ui-ng-session-timer',
  'ui-ng-sibling',
  'ui-ng-smooth-scroll',
  'ui-ng-sticky',
  'ui-ng-svg-icons',
  'ui-ng-time-input',
  'ui-ng-tooltip',
  'ui-ng-validation',
  'ui-ng-university-text',
  'ui-ng-app-content',
  'ui-ng-browser-detect',
  'ui-ng-calendar',
  'ui-ng-component-communicator',
  'ui-ng-content-tabs',
  'ui-ng-content-tile',
  'ui-ng-delegate',
  'ui-ng-mobile-date-picker',
  'ui-ng-navbar',
  'ui-ng-popup',
  'ui-ng-refresh-button',
  'ui-ng-resource-card',
  'ui-ng-route-modal',
  'ui-ng-schedule-appointment-card',
  'ui-ng-search-box',
  'ui-ng-sgd-components',
  'ui-ng-university-branding',
  'ui-ng-week-times',
  'utility-ng-log',
  'utility-ng-network-cache',
  'utility-ng-pipeline',
  'utility-ng-time',
  'utility-ng-webcrypto',
  'utility-ng-auth-token',
  'utility-ng-configuration',
  'utility-ng-enumeration',
  'utility-ng-interface',
  'utility-ng-kernel',
  'utility-ng-progression',
  'utility-ng-type',
  'capability-ng-academic-planner',
  'capability-ng-appointments',
  'capability-ng-authentication',
  'capability-ng-conversations',
  'capability-ng-course-schedule',
  'capability-ng-deeplink',
  'capability-ng-favorites',
  'capability-ng-holds',
  'capability-ng-major-explorer',
  'capability-ng-notification-settings',
  'capability-ng-poll',
  'capability-ng-priority-feed',
  'capability-ng-reports',
  'capability-ng-resources',
  'capability-ng-scheduler',
  'capability-ng-settings',
  // 'capability-ng-student-scheduling',
  'capability-ng-study-groups',
  'capability-ng-survey',
  'capability-ng-todos',
  'biz-ng-career-details',
  'biz-ng-path-placement',
  'biz-ng-requisite-tree',
  'hybrid-ng-personal-reminders'
]);



// WEBPACK FOOTER //
// ./app/index.ts